export default __webpack_public_path__ + "7828bc2ca26c6eab33413658e802ccf7.webp";